<div class="hero"></div>
<div class="hero-content">
  <h1 class="text">Welcome to Pixel Pro</h1>
  <span class="text">"Outside the Box"</span>
  <p class="text">
    Discover expertly crafted software solutions tailored to elevate your
    business. Our offerings include cutting-edge data analytics, seamless APIs,
    and smart insights that drive dynamic decision-making and operational
    excellence.
  </p>
  <button class="btn" routerLink="/smart-restaurant-suite">
    Our Products
    <i class="icon"
      ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
          d="M9 6L15 12L9 18M9 12H9.01"
          stroke="#fff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        /></svg
    ></i>
  </button>
</div>
